<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/cards/', query: backQuery }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>{{ title }}</h1>
          <h2 style="margin:0 0 30px 0;" v-if="this.$route.query.cardID == undefined">Ez a felület a kártyarendszerben nem létező kártyák felvitelére szolgál, csak kivételes esetekben ajánlott a használata!</h2>
          <div class="row">
            <div class="col-sm-4">
              <ul class="list-with-icon" v-if="szakok.length > 0">
                <li v-for="(szak, i) in szakok">
                  <i style="color: green;" v-if="szak.statusz == 'Aktív'" class="icon fa fa-check-circle"></i>
                  <i style="color: #d6e1e5;" v-if="szak.statusz != 'Aktív'" class="icon far fa-times-circle"></i>
                  {{ szak.szak }} ({{ szak.szakkod }}) - {{ szak.tagozat }}
                </li>
              </ul>
              <inputbox :disabled="this.$route.query.cardID != undefined" id="owner_name" label="Tulajdonos" :errors="errors" name="owner_name" v-model="form.owner_name"></inputbox>
              <inputbox v-if="up_email != ''" disabled id="up_email" label="E-mail cím" name="up_email" v-model="up_email"></inputbox>
              <inputbox v-if="email != ''" disabled id="email" label="E-mail cím" name="email" v-model="email"></inputbox>
              <inputbox v-if="this.$route.query.cardID != undefined" disabled id="card_number" label="Kártyaszám" :errors="errors" name="card_number" v-model="form.card_number"></inputbox>
              <inputbox :disabled="this.$route.query.cardID != undefined" id="rf_id" :label="this.$route.query.cardID != undefined ? 'RF ID' : 'RF ID (Beolvasáshoz érintse a kártyát az olvasóhoz)'" :errors="errors" name="rf_id" v-model="form.rf_id"></inputbox>

              <div class="form-group">
                <label class="form-label">Rendszámok</label>
                <table v-for="(plate, index) in form.plates" :key="'plateid:' + plate.id">
                  <tr>
                    <td>
                      <inputbox :id="'plate-' + index" name="'plate-' + index" :errors="errors" v-model="plate.number"></inputbox>
                    </td>
                    <td class="buttons">
                      <button v-if="!plate.active_season_ticket" class="button" @click="deletePlate(index)"><i class="fa fa-trash"></i></button>
                      <i v-else class="fa fa-exclamation-circle fa-lg" style="color: #C25450;" title="Bérlethez rendelt rendszám. A törlése nem engedélyezett."></i>
                    </td>
                  </tr>
                </table>
              </div>
              <button class="button" style="width: 100%" @click="addPlate">
                <i class="fa fa-plus"></i> Új rendszám
              </button>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="form-label">Access levels</label>
                <ul v-if="form.access_level_ids.length > 0" class="selected-tags">
                  <li v-for="id in form.access_level_ids"><span @click="accessLevelDel(id)">×</span>{{ getAccessLevelTitle(id) }}</li>
                </ul>
              </div>

              <!--<select2 multi="true" v-bind:errors="errors" label="Access Levels" name="access_level_ids" id="access_level_ids" :options="access_levels" v-model="form.access_level_ids"/>-->
              <div style="display: flex; align-items: center;">
                <select2 ref="new_access_level_id" style="width: 100%;" placeholder="Új access level" name="new_access_level_id" id="new_access_level_id" :options="new_access_levels" v-model="new_access_level_id"/>
                <div style="padding-left: 10px;" class="form-group">
                  <label class="form-label"></label>
                  <button :disabled="new_access_level_id == 0" @click="addAccessLevel" type="button" class="button small"><i class="fa fa-plus"></i></button>
                </div>
              </div>
            </div>
          </div>
          <section v-if="this.$route.query.cardID != undefined">
            <hr>
            <div class="row">
              <div class="col-xs-12">
                <h2>Eseménynapló</h2>
                <table class="list">
                  <thead>
                    <tr>
                      <th>Adminisztrátor</th>
                      <th>Módosítva</th>
                      <th>Változás</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(log, i) in logs">
                      <tr :key="'log:' + i" v-if="log.changes.access_levels.length || log.changes.plates.length">
                        <td :style="tdStyle(log)">{{ log.name }}</td>
                        <td :style="tdStyle(log)">{{ log.created }}</td>
                        <td :style="tdStyle(log)">
                          <div v-for="(change, i) in log.changes.access_levels" :key="'change_access_level:' + i" style="padding: 4px; margin-bottom: 1px" :title="getChangeTitle(change.action)">
                            <i :style="{ color: getChangeBackground(change.action) }" :class="{ 'fas fa-plus-circle': change.action === 'add', 'fas fa-minus-circle': change.action === 'remove' }"></i>
                            [Access Level] {{ getAccessLevelNameByID(change.value) }}
                          </div>
                          <div v-for="(change, i) in log.changes.plates" :key="'change_plate:' + i" style="padding: 4px; margin-bottom: 1px" :title="getChangeTitle(change.action)">
                            <i :style="{ color: getChangeBackground(change.action) }" :class="{ 'fas fa-plus-circle': change.action === 'add', 'fas fa-minus-circle': change.action === 'remove' }"></i>
                            [Rendszám] "{{ change.value }}"
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      form: {
        element_id: '',
        owner_name: '',
        card_number: '',
        rf_id: '',
        access_level_ids: [],
        plates: [],
      },
      new_access_level_id: 0,
      new_access_levels: [],
      up_email: '',
      email: '',
      logs: [],
      szakok: [],
      access_levels: [],
      parking_penalties: [],
      parking_penalty: {
        start_date: '',
        interval: '1 MONTH',
        reason: ''
      },
      errors: [],
      is_save: false,
      socket: ''
    }
  },

  created: function() {
    if(this.$route.query.cardID == undefined) {
      this.watchCardReader();
    }
  },

  beforeDestroy: function() {
    this.socket.close();
  },

  mounted: function() {
    var _this = this;
    this.$root.checkRootUserHasSet(function() {
      _this.getAccessLevels();
      if(_this.$route.query.cardID != undefined) {
        _this.$root.ajax('card/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.cardID != undefined ? _this.$route.query.cardID : 0), {
          success: function(response) {
            _this.form = response.card;
            _this.email = response.email;
            _this.up_email = response.up_email;
            _this.getLatestLogs();
            _this.getPlates();
            _this.getLatestParkingPenalties();
            _this.szakok = response.szakok;
          }
        });
      }
    });
  },

  computed: {
    title: function() {
      return this.$route.query.cardID != undefined ? "Kártya" : "Új kártya";
    },
    backQuery() {
      if (this.$route.query != undefined) {
        var t = JSON.parse(JSON.stringify(this.$route.query));
        delete t.cardID;
        return t;
      }
    }
  },

  methods: {
    getAccessLevelTitle: function(id) {
      var title = '';
      this.access_levels.map(function(al) {
        if (parseInt(al.value) == parseInt(id))
          title = al.label;
      });
      return title;
    },

    setNewAccessLevels: function() {
      var _this = this;
      this.new_access_levels = [];
      this.access_levels.map(function(al) {
        if (_this.form.access_level_ids.indexOf(al.value) < 0)
          _this.new_access_levels.push(al);
      });
      setTimeout(function() {
        _this.$refs['new_access_level_id'].reload();
      }, 100);
    },

    accessLevelDel: function(id) {
      this.form.access_level_ids = this.form.access_level_ids.filter(function(value, index, arr){ return value != id;});
      this.new_access_level_id = 0;
      this.setNewAccessLevels();
    },

    addAccessLevel: function() {
      var _this = this;
      var can_be_added = false;

      this.access_levels.map(function(al) {
        if (parseInt(al.value) == parseInt(_this.new_access_level_id))
          can_be_added = true;
      });

      if (can_be_added) {
        this.form.access_level_ids.push(parseInt(this.new_access_level_id));
        this.new_access_level_id = 0;
        this.setNewAccessLevels();
      }
    },

    tdStyle: function(log) {
      return {
        'background-color': log.row_background_color,
        'color': log.row_text_color
      }
    },

    getPlates: function() {
      var _this = this;
      _this.$root.ajax('plates/' + _this.$root.user.apikey, {
        method: 'POST',
        data: {
          card_id: _this.form.element_id
        },
        success: function(response) {
          _this.form.plates = response.plates;
          _this.$forceUpdate();
        }
      });
    },
    deletePlate: function(index) {
      this.$delete(this.form.plates, index);
      this.$forceUpdate();
    },
    addPlate: function() {
      this.form.plates.push({ number: '' });
      this.$forceUpdate();
    },

    getLatestLogs: function() {
      var _this = this;
      _this.$root.ajax('logs/' + _this.$root.user.apikey, {
        method: 'POST',
        data: {
          limit: 20,
          params: '"to_element_id":"' + _this.$route.query.cardID + '"'
        },
        success: function(response) {
          _this.logs = response.logs;
          var last_access_level_ids = [];
          var last_plate_numbers = [];
          for (const log of _this.logs.reverse()) {
            log.params = JSON.parse(log.params);
            log.changes = {
              access_levels: [],
              plates: []
            };

            if (log.params.access_level_ids) {
              for (const access_level_id of log.params.access_level_ids) {
                if (!last_access_level_ids.includes(access_level_id)) {
                  log.changes.access_levels.push({ action: 'add', value: access_level_id });
                }
              }
              for (const access_level_id of last_access_level_ids) {
                if (!log.params.access_level_ids.includes(access_level_id)) {
                  log.changes.access_levels.push({ action: 'remove', value: access_level_id });
                }
              }
            }

            if (log.params.plate_numbers) {
              for (const plate_number of log.params.plate_numbers) {
                if (!last_plate_numbers.includes(plate_number)) {
                  log.changes.plates.push({ action: 'add', value: plate_number });
                }
              }
              for (const plate_number of last_plate_numbers) {
                if (!log.params.plate_numbers.includes(plate_number)) {
                  log.changes.plates.push({ action: 'remove', value: plate_number });
                }
              }
            }

            last_access_level_ids = log.params.access_level_ids || [];
            last_plate_numbers = log.params.plate_numbers || [];
          }
          _this.logs.reverse();
        }
      });
    },

    getLatestParkingPenalties: function(limit) {
      if (limit === undefined) { limit = 10; }
      var _this = this;
      _this.$root.ajax('parking_penalties/' + _this.$root.user.apikey, {
        method: 'POST',
        data: {
          limit,
          params: '"card_id":"' + _this.$route.query.cardID + '"',
          card_id: _this.$route.query.cardID,
          active: 1
        },
        success: function(response) {
          _this.parking_penalties = response.parking_penalties;
          for (const penalty of _this.parking_penalties) {
            penalty.editing = false;
          }
        }
      });
    },
    saveParkingPenalty: function(data) {
      var _this = this;
      _this.errors = [];
      _this.$root.ajax('parking_penalties/save/' + _this.$root.user.apikey, {
        method: 'POST',
        data: {
          card_id:    _this.$route.query.cardID,
          start_date: data.start_date,
          interval:   data.interval,
          reason:     data.reason
        },
        success: function(response) {
          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.getLatestParkingPenalties();
            _this.parking_penalty = {
              start_date: '',
              interval: '1 MONTH',
              reason: ''
            };
          }
        }
      });
    },
    editParkingPenalty: function(data) {
      console.log(data);
      var _this = this;
      _this.errors = [];
      _this.$root.ajax('parking_penalties/edit/' + _this.$root.user.apikey, {
        method: 'POST',
        data: {
          id:         data.id,
          start_date: data.start_date,
          end_date:   data.end_date,
          reason:     data.reason
        },
        success: function(response) {
          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.getLatestParkingPenalties();
          }
        }
      });
    },
    deleteParkingPenalty: function(id) {
      var _this = this;
      _this.$root.ajax('parking_penalties/delete/' + _this.$root.user.apikey, {
        method: 'POST',
        data: {
          id
        },
        success: function(response) {
          _this.getLatestParkingPenalties();
        }
      });
    },

    getAccessLevels: function() {
      var _this = this;

      _this.$root.ajax('access_levels/' + _this.$root.user.apikey + '/1', {
        method: 'POST',
        success: function(response) {
          var tmp = [];
          response.access_levels.map(function(item) {
            tmp.push({
              label: item.name,
              value: item.element_id
            });
          });
          _this.access_levels = tmp;
          _this.setNewAccessLevels();
        }
      });
    },

    save: function(event) {
      var _this = this;
      _this.form.plates.forEach((plate, index) => {
        plate.input_id = 'plate-' + index;
      });
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('card/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              if(_this.$route.query.cardID == undefined) {
                _this.$router.push({path: '/cards'});
              } else {
                location.reload();
              }
            }
          }
        });
      });
    },

    watchCardReader: function() {
      if (this.socket.readyState === WebSocket.OPEN) {
        this.socket.close();
      }

      var _this = this;
      try {
        this.socket = new WebSocket("wss://kmr-reader.uninet.hu:8080");

        this.socket.onmessage = function (event) {
          if (event.data != undefined) {
            _this.form.rf_id = event.data;
          }
        };
      } catch(err) {

      }
    },

    getChangeTitle: function(action) {
      if (action === 'add') return 'Hozzáadás';
      if (action === 'remove') return 'Törlés';
    },
    getChangeBackground: function(action) {
      if (action === 'add') return '#89bd4f';
      if (action === 'remove') return '#c26360';
    },
    getAccessLevelNameByID: function(id) {
      for (const access_level of this.access_levels) {
        if (access_level.value == id) {
          return access_level.label;
        }
      }
      return 'Nem található access level ('+ id +')';
    }
  }
}
</script>



// WEBPACK FOOTER //
// card.vue?6b7e0a3c